export const CLASS_NAMES = {
  label:
    "text-10-17-em md:text-14-22 text-neutral-500 md:text-neutral-700 normal-case ",
};

export const HIGHLIGHT_PROPS = {
  highlightClassName: "text-turquoise-300 bg-transparent",
  autoEscape: true,
};
